// DESIGN_SYSTEM_NOTES: wfm-loading and --wfm-primary only.
//
// The in-page loading slot. Extracted from pages/workforce/wfShared.jsx
// (which now re-exports it). For skeleton placeholders use components/Skeleton.

import React from 'react';
import { Loader2 } from 'lucide-react';

export default function Loading({ size = 32 }) {
  return (
    <div className="wfm-loading">
      <Loader2 size={size} className="animate-spin" style={{ color: 'var(--wfm-primary)' }} />
    </div>
  );
}
